export enum PushFlow {
  PushPlan = 'push_plan',
  ScheduledInvites = 'scheduled_invites',
}
